import { styled } from 'styled-components'

import {
  errorContainer,
  onErrorContainer,
  onPrimaryContainer,
  onSuccessContainer,
  onSurface,
  onSurfaceDisabled,
  onWarningContainer,
  outline,
  primaryContainer,
  successContainer,
  surface,
  surfaceBright,
  surfaceDim,
  surfaceDisabled,
  warningContainer,
} from 'core/styles'

export type ChipProps = {
  $variant?: 'primary' | 'success' | 'error' | 'warning' | 'dim' | 'disabled' | 'bright' | 'dark'
  $size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const Chip = styled.div<ChipProps>`
  display: inline-flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  padding: 0 8px;
  line-height: 1.5;
  font-weight: 500;

  ${(p) =>
    p.$variant === 'primary' ?
      `
      background-color: ${primaryContainer};
      color: ${onPrimaryContainer};
      `
    : p.$variant === 'success' ?
      `
      background-color: ${successContainer};
      color: ${onSuccessContainer};
      `
    : p.$variant === 'error' ?
      `
      background-color: ${errorContainer};
      color: ${onErrorContainer};
      `
    : p.$variant === 'warning' ?
      `
      background-color: ${warningContainer};
      color: ${onWarningContainer};
      `
    : p.$variant === 'dim' ?
      `
      background-color: ${surfaceDim};
      color: ${onSurface};
      `
    : p.$variant === 'disabled' ?
      `
      background-color: ${surfaceDisabled};
      color: ${onSurfaceDisabled};
      `
    : p.$variant === 'dark' ?
      `
      background-color: ${onSurface};
      color: ${surface};
      `
    : `
      background-color: ${surfaceBright};
      color: ${onSurface};
      border: 1px solid ${outline};
      `}

  ${(p) =>
    p.$size === 'sm' ?
      `
      height: 16px;
      font-size: 10px;
      `
    : p.$size === 'lg' ?
      `
      height: 24px;
      font-size: 14px;
      `
    : p.$size === 'xl' ?
      `
      height: 28px;
      font-size: 16px;
      `
    : `
      height: 20px;
      font-size: 12px;
      `}
`

export default Chip
